import { render, staticRenderFns } from "./SelectPlan.vue?vue&type=template&id=470adaca&scoped=true&"
import script from "./SelectPlan.vue?vue&type=script&lang=js&"
export * from "./SelectPlan.vue?vue&type=script&lang=js&"
import style0 from "./SelectPlan.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SelectPlan.vue?vue&type=style&index=1&id=470adaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470adaca",
  null
  
)

export default component.exports